import { useFeatureFlagContext } from '@/javascript/providers/FeatureFlagContext/FeatureFlagContext'

// This hook is used to determine the class name for a feature based on the PDP_V2_FLAG.
export const useFeatureClassName = (trueClass = '', falseClass = 'top-border') => {
  const { PDP_V2_FLAG } = useFeatureFlagContext()
  return {
    className: PDP_V2_FLAG ? trueClass : falseClass
  }
}
